import classNames from 'classnames';
import {isEmpty} from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import flattenDeep from 'lodash/flattenDeep';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchMatchDays} from '../../../../../../actions/entities/match';
import {fetchStatsMatchesGoals} from '../../../../../../actions/entities/statistics/matches';
import Filters from '../../../../../../components/Filters';
import FilterGamesWeek from '../../../../../../components/Filters/GamesWeek';
import FilterLeague from '../../../../../../components/Filters/League';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterSeason from '../../../../../../components/Filters/Season';
import Loader from '../../../../../../components/Loader';
import './index.css';
import {getChampionships} from '../../../../../../actions/entities/championships';
import {getChampionshipId} from '../../../../../../helpers/championship';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';

class StatsMatchesGoalsWidget extends React.Component {
  constructor(props) {
    super(props);

    const month = moment().month();
    const year = moment().year();
    // Si on est en août ou plus la saison est l'année en cours.
    // Année en cours = 2018
    // Si mois < août Alors saison = 2017 Sinon saison = 2018
    const season = month >= 6 ? year : year - 1;

    this.state = {
      filters: {
        championship: 'FR',
        league: {nbPlayers: []},
        season,
        gamesWeeks: [],
      },
      order: {key: 'goals', value: 'desc'},
      isFetching: false,
      matchDays: {},
      highlightRefreshBtn: false,
    };
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'teamMatches':
          newOrder.value = 'asc';
          break;
        case 'percentTeamWithThisNbOfMatches':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  onError = error => {
    this.setState({isFetching: false});
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong !<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  fetchMatchDays() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: response => {
        this.setState({isFetching: false, matchDays: response});
        this.fetchStats();
      },
    };

    if (!this.state.isFetching) {
      const {season} = this.state.filters;
      const payload = {season};
      this.props.dispatch(fetchMatchDays(payload, callBacks));
    }
  }

  fetchStats() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching) {
      const {season} = this.state.filters;
      const payload = {season};
      this.props.dispatch(fetchStatsMatchesGoals(payload, callBacks));
    }
  }

  static getSeasonOptions() {
    const year = moment().year();
    const season = moment().month() >= 7 ? year : year - 1;

    const seasonOptions = [];
    for (let i = parseInt(season, 10); i >= 2017; i--) {
      seasonOptions.push({value: i.toString(), text: `${i} - ${i + 1}`});
    }

    return seasonOptions;
  }

  getGamesWeekOptions() {
    const {matchDays, filters} = this.state;
    const matchDaysByChamp =
      matchDays?.championships?.[getChampionshipId(filters.championship)]
        ?.gameWeekNumbers;
    return (
      matchDaysByChamp &&
      matchDaysByChamp.map(day => ({value: day, text: `Day ${day}`}))
    );
  }

  static getPercent(nb, total) {
    const percent = (parseInt(nb, 10) / total) * 100;
    return parseInt(numeral(percent > 100 ? 100 : percent).format('0,0'), 10);
  }

  getSumsByFilters() {
    const {filters} = this.state;
    const {data} = this.props;
    if (
      !data ||
      (data?.gameWeeks && Object.keys(data.gameWeeks).length === 0)
    ) {
      return null;
    }

    delete data.type;
    delete data.id;

    let filteredData = filter(
      data.gameWeeks,
      (value, key) =>
        filters.gamesWeeks.length === 0 || filters.gamesWeeks.includes(key),
    );

    if (filteredData.length === 0) return null;

    const championship = getChampionshipId(filters.championship);
    filteredData = flattenDeep(
      filteredData.map(values =>
        filter(
          values.championships,
          (value, key) => parseInt(key, 10) === parseInt(championship, 10),
        ),
      ),
    );

    if (filteredData.length === 0) return null;

    filteredData = flattenDeep(
      filteredData.map(values =>
        filter(values.divisionSizes, (value, key) => {
          return (
            filters.league.nbPlayers.length === 0 ||
            filters.league.nbPlayers.includes(parseInt(key, 10))
          );
        }),
      ),
    );

    const sums = cloneDeep(filteredData[0]);
    if (!sums) return null;

    for (let i = 1; i < filteredData.length; i += 1) {
      const dataToAdd = filteredData[i];
      sums.goals += dataToAdd.goals;
      sums.mpgGoals += dataToAdd.mpgGoals;
      sums.mpgStops += dataToAdd.mpgStops;
      sums.totalMatches += dataToAdd.totalMatches;
      Object.keys(sums.badges).forEach(
        key => (sums.badges[key] += dataToAdd.badges[key]),
      );
    }

    return sums;
  }

  componentDidMount() {
    this.fetchMatchDays();
    this.props.dispatch(getChampionships());
  }

  renderTable() {
    const {order} = this.state;
    const cols = {
      goals: 'Real goals',
      mpgGoals: 'MPG goals',
      mpgStops: 'MPG stops',
    };

    const data = this.getSumsByFilters();

    console.log(data);
    return !data ? (
      <p className="text-center px-3 pb-3">No data to show</p>
    ) : (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>{this.renderThs(cols, true)}</tr>
          </thead>
          <tbody>
            {orderBy([data], [order.key], [order.value]).map((goals, i) => (
              <tr key={i}>
                {map(cols, (value, key) => (
                  <td key={`nb-${goals}-${key}`}>
                    {numeral(goals[key] / goals.totalMatches).format('0,0.00')}
                    {key.indexOf('percent') > -1 && ' %'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderThs(cols, hideSort = false) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key && !hideSort,
          })}>
          {value}
          <span className={classNames('ml-1', {hidden: hideSort})}>
            <i
              className={classNames('fa', {
                'fa-sort': order.key !== key,
                [`fa-sort-${order.value}`]: order.key === key,
              })}
            />
          </span>
        </span>
      </th>
    ));
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const {championships} = this.props;
    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="stats-matches-goals-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-futbol-o" />
              {` Average goals per match`}
            </h3>
          </div>
          <div className="box-body">
            <Filters>
              <FilterLocation
                label="Championship:"
                availableButtons={getAvailableFlagsButtons(
                  this.props.championships,
                )}
                onChange={championship => this.updateFilters({championship})}
                initialValue={this.state.filters.championship}
              />
              <FilterLeague
                label="Leagues:"
                onChange={league => this.updateFilters({league})}
                initialValues={this.state.filters.league}
              />
              <FilterSeason
                label="Season:"
                onChange={season => {
                  this.updateFilters({season});
                  this.notifyRefresh(true);
                }}
                options={StatsMatchesGoalsWidget.getSeasonOptions()}
                initialValue={this.state.filters.season.toString()}
              />
              <FilterGamesWeek
                label="Match days:"
                onChange={gamesWeeks => this.updateFilters({gamesWeeks})}
                options={this.getGamesWeekOptions()}
                selectProps={{multiple: true}}
              />
              <button
                onClick={this.fetchMatchDays.bind(this)}
                className={classNames('btn btn-submit', {
                  'btn-default': !highlightRefreshBtn,
                  'btn-success': highlightRefreshBtn,
                })}>
                <i
                  className={classNames('fa fa-refresh', {
                    'fa-spin': isFetching,
                  })}
                />
              </button>
            </Filters>
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, championships} = state.app;
    return {
      data: statistics.matches.goals,
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(StatsMatchesGoalsWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Matches/Goals/index.js